import React from 'react';

import './styles.css';
import type { Props } from './types';

const IDLE_ANCHOR =
  'font-semibold text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 dark:hover:text-gray-100';
// Matches SidebarNavRail's selected treatment; see the note there about the `!`.
const ACTIVE_ANCHOR = 'bg-green-50 font-bold text-green-950 dark:bg-green-950! dark:text-green-50';

/**
 * The second level under a rail entry: the cards on the page you are already looking at, each one
 * a jump to its position.
 *
 * Indented under its parent link and tied to it with a rule, so the section links stay the primary
 * level and these read as belonging to the one that is open.
 */
const PageAnchorList = ({ anchors, activeAnchorId, onJump }: Props) => (
  <ul
    aria-label="On this page"
    className="page-anchor-list mt-1 mb-1 ml-5 overflow-y-auto border-l border-gray-200 pl-2">
    {anchors.map(({ id, label }) => {
      const current = id === activeAnchorId;

      return (
        <li key={id}>
          <button
            type="button"
            onClick={() => onJump(id)}
            aria-current={current ? 'location' : undefined}
            className={`flex w-full items-center rounded-md px-2 py-1.5 text-left text-xs ${
              current ? ACTIVE_ANCHOR : IDLE_ANCHOR
            }`}>
            <span className="truncate">{label}</span>
          </button>
        </li>
      );
    })}
  </ul>
);

export default React.memo(PageAnchorList);
